import { Plugins } from '@leverege/plugin';
import Bold from "./Bold.js";
import Italics from "./Italics.js";
import Strikethrough from "./Strikethrough.js";
import Underline from "./Underline.js";
import Code from "./Code.js";
import ClearMarks from "./ClearMarks.js";
import Link from "./Link.js";
import Image from "./Image.js";
import Color from "./Color.js";
import FontSize from "./FontSize.js";
import Heading from "./Heading.js";
import Alignment from "./Alignment.js";
import OrderedList from "./OrderedList.js";
import UnorderedList from "./UnorderedList.js";
import Paragraph from "./Paragraph.js";
import Attribute from "./Attribute.js";
import Variant from "./Variant.js";
export default {
  install: opts => {
    Plugins.addPlugin('Action', Bold);
    Plugins.addPlugin('Action', Italics);
    Plugins.addPlugin('Action', Strikethrough);
    Plugins.addPlugin('Action', Underline);
    Plugins.addPlugin('Action', Code);
    Plugins.addPlugin('Action', ClearMarks);
    Plugins.addPlugin('Action', Link);
    Plugins.addPlugin('Action', Image);
    Plugins.addPlugin('Action', Color);
    Plugins.addPlugin('Action', Variant);
    Plugins.addPlugin('Action', FontSize);
    Plugins.addPlugin('Action', Paragraph);
    Plugins.addPlugin('Action', Heading(1));
    Plugins.addPlugin('Action', Heading(2));
    Plugins.addPlugin('Action', Heading(3));
    Plugins.addPlugin('Action', OrderedList);
    Plugins.addPlugin('Action', UnorderedList);
    Plugins.addPlugin('Action', Attribute);
    Plugins.addPlugin('Action', Alignment);
  }
};